export function applyWhiteBackground(blob: Blob): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const imageUrl = URL.createObjectURL(blob);
    const image = new Image();

    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext('2d');

      if (!context) {
        URL.revokeObjectURL(imageUrl);
        reject(new Error('Unable to create canvas context'));
        return;
      }

      context.fillStyle = '#FFFFFF';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0);

      canvas.toBlob(result => {
        URL.revokeObjectURL(imageUrl);
        if (!result) {
          reject(new Error('Unable to generate image blob'));
          return;
        }
        resolve(result);
      }, 'image/png');
    };

    image.onerror = () => {
      URL.revokeObjectURL(imageUrl);
      reject(new Error('Unable to load image blob'));
    };

    image.src = imageUrl;
  });
}

type ClosableDialogRef<T = unknown> = {
  close: (dialogResult?: T | null) => void;
};

export async function closeCroppedImageWithWhiteBackground(
  dialogRef: ClosableDialogRef<Blob>,
  croppedImage: Blob | null
): Promise<void> {
  if (!croppedImage) {
    dialogRef.close(null);
    return;
  }

  try {
    const imageWithWhiteBackground = await applyWhiteBackground(croppedImage);
    dialogRef.close(imageWithWhiteBackground);
  } catch (error) {
    console.error('Failed to apply white background to cropped image:', error);
    dialogRef.close(croppedImage);
  }
}
